interface MenuTree {
    title: string;
    relative: string;
    below: MenuTree[];
}

export interface BreadcrumbPiece {
    title: string;
    url: string;
}

export function findPageInMenuTree(page: string, tree: MenuTree): BreadcrumbPiece[] | undefined {

    let path: BreadcrumbPiece[] = [{title: tree.title, url: tree.relative}];
    if (arePathsEquals(tree.relative, page)) {
        return path;
    }

    // We recursively look for the item in each child
    if (tree.below && tree.below.length) {
        for (let subtree of tree.below) {
            let subpath: BreadcrumbPiece[] | undefined = findPageInMenuTree(page, subtree);
            if (subpath) {
                return path.concat(subpath);
            }
        }
    }

    return undefined;
}

/**
 * Check if both path1 and path2 referring to the same page
 *
 * @param path1
 * @param path2
 */
function arePathsEquals(path1: string, path2: string): boolean {
    if (path1 === path2) return true;

    if (path1.startsWith("/it/") || path1.startsWith("/en/")) {
        path1 = path1.substring(3);
    }

    if (path2.startsWith("/it/") || path2.startsWith("/en/")) {
        path2 = path2.substring(3);
    }

    return path1 === path2;
}